<script setup lang="ts">
import { computed } from 'vue'

import { CommonResultId } from '@collector/sportsapi-client-legacy'
import {
  useEvent,
  useParticipantResult,
} from '@desktop/views/Relation/composables'
import { injectResultWithSliderConfig } from '@desktop/views/Relation/Sports/provide-inject'

const { eventStatusToResultIdMap, resultIdToAcronymMap } =
  injectResultWithSliderConfig()!

const { getHomeParticipantResult, getAwayParticipantResult } =
  useParticipantResult()
const { event } = useEvent()

const currentResultId = computed(() =>
  eventStatusToResultIdMap.get(event.value.status_id),
)

const currentResultAcronym = computed(() => {
  return (
    (currentResultId.value &&
      resultIdToAcronymMap.get(currentResultId.value)) ||
    ''
  )
})
</script>

<template>
  <div class="flex flex-col gap-y-1">
    <div class="text-center text-xs font-bold text-nowrap select-none">
      RESULT {{ getHomeParticipantResult(CommonResultId.Result) }} :
      {{ getAwayParticipantResult(CommonResultId.Result) }}
    </div>
    <div class="h-4 text-center text-xs font-bold text-nowrap select-none">
      {{ currentResultAcronym }}
    </div>
  </div>
</template>
